import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConnectionTypeModel } from 'src/app/Model/ConnectionType.model';
import { CountryModel } from 'src/app/Model/Country.model';
import { RequestModel } from "src/app/Model/Request.model";
import { VcontractsModel } from 'src/app/Model/Vcontracts.model';
import { ConnectionTypeService } from 'src/app/Services/connection-type/ConnectionType.service';
import { ContractsService } from 'src/app/Services/contracts/contracts.service';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { MatTableHelpers } from 'src/app/Util/MatTableHelpers';
import Swal from "sweetalert2";

import { JSONToExcel } from "simplified-json-to-excel";
import { VcontractsExcelModel } from 'src/app/Model/VcontractsExcel.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.css']
})
export class ContractsComponent {
  @ViewChild('myTemplate', { static: false }) customTemplate: TemplateRef<any>;

  filterValue = '';
  elementData: VcontractsModel[];
  filterItem: VcontractsModel[];
  elemPolicy: VcontractsModel[];
  lstCountries: CountryModel[];
  lstConnection: ConnectionTypeModel[];
  filterItemExcel: VcontractsExcelModel[] = [];
  SearchCode: string;
  NameAgency: string;
  RequestModal: VcontractsModel;
  Idstatus: string;
  IdCountry: number;
  LstResquest: Array<VcontractsModel> = [];
  IdConnection: number;
  public Request: RequestModel;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = [ 'AgreementTypeNameFirst', 'Status', 'Iata', 'AgencyType', 'NameConnection', 'ComercialName', 'Nit', 'RequestDate', 'NotifyDate', 'LegalName', 'LegalDocName', 'LegalDocNumber', 'RegionName', 'CountryName', 'StateCrm', 'PolicyStartDate', 'PolicyEndDate', 'WarrantyNumber', 'WarrantyType', 'actions' , 'policy'];
  dataSource: MatTableDataSource<VcontractsModel>;
  public requestcode;
  public iata;

  constructor(
    public dialog: MatDialog,
    private readonly contractsService: ContractsService,
    private readonly ServiceConnection: ConnectionTypeService,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly crmGeoService: crmGeoService,
    private readonly activeRoute: ActivatedRoute,
    private readonly Service: DocumentService,
    private readonly lsService : SessionStorageService) {
  }

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });


  async ngOnInit() {
    if (this.activeRoute.snapshot.params.iata == undefined) {
      this.requestcode = this.lsService.getLSItem("RequestCode");
      this.iata = ""
    } else {
      this.iata = this.activeRoute.snapshot.params.iata
    }
  }

  async ngAfterViewInit() {

    await this.loadContracts();
    await this.crmGeoService.getCountries().then(res => {
      this.lstCountries = res;
    });
    await this.ServiceConnection.getConnectionType().then(res => {
      this.lstConnection = res;
    });

  }


  openDialog(row: VcontractsModel): void {

    this.RequestModal = row
    const dialogRef = this.dialog.open(this.customTemplate, {

    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }


  async loadContracts() {
    this.spinner.show()

    await this.contractsService.getContract().then(async res => {
      this.elementData = res;
    });
    this.filter();

    this.dataSource.sortingDataAccessor = (data, sortHeaderId: string) => {
      return MatTableHelpers.getPropertyByPath(data, sortHeaderId);
    };
    this.updateFilter();

    this.spinner.hide()
 
  }

  filter() {
    this.spinner.show()
    
    this.filterItem = this.elementData;

    if (this.SearchCode != '' && this.SearchCode != null) {
      this.filterItem = this.filterItem.filter(x => x.Iata?.includes(this.SearchCode) || x.CodeIata?.includes(this.SearchCode))
    }
    if (this.NameAgency != '' && this.NameAgency != null) {
      this.filterItem = this.filterItem.filter(x => x.NameAgency.toLowerCase().includes(this.NameAgency.toLowerCase()))
    }
    if (this.Idstatus != "0" && this.Idstatus != null) {

      this.filterItem = this.filterItem.filter(x => x.Status == this.Idstatus)

    }

    if (this.IdCountry != null && this.IdCountry != 0) {
      this.filterItem = this.filterItem.filter(x => x.IdCountry == this.IdCountry)
    }

    if (this.IdCountry != null && this.IdCountry != 0) {
      this.filterItem = this.filterItem.filter(x => x.IdCountry == this.IdCountry)
    }

    if (this.IdConnection != null && this.IdConnection != 0) {
      this.filterItem = this.filterItem.filter(x => x.ConnectionType == this.IdConnection)
    }

    if (this.range.value.start != null && this.range.value.end != null) {
      this.filterItem = this.filterItem.filter(x => {
        let date = new Date(x.RequestDate)
        let date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
        return date2.getTime() >= this.range.value.start.getTime() && date2.getTime() <= this.range.value.end.getTime()
      })
    }

    if (this.activeRoute.snapshot.params.requestcode == undefined) {
      this.filterItem = this.filterItem.filter(x => x.Iata?.includes(this.iata) || x.CodeIata?.includes(this.iata))
    }
    else{
      this.filterItem = []
    }

    this.elemPolicy = this.filterItem
    this.dataSource = new MatTableDataSource(this.filterItem);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  updateFilter() {
    this.dataSource.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  DirectDownload(contract: VcontractsModel) {
    fetch(contract.ContractUrl, {
      method: 'GET'
    }).then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        let dateString = moment(contract.RequestDate).format('DDMMYYYY');
        a.download = dateString + '-' + contract.NameAgency + '-' + contract.NameConnection + ".docx"
       document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
  }


  async DocumentPrint(row: VcontractsModel) { 
    let textoHtml:string
    this.spinner.show();
    await this.contractsService.getUrlTyC(row.Id).then(async (res) => {
      textoHtml = res;
    });
    this.spinner.hide();

    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0,noopener,noreferrer');

    WindowPrt.document.write(textoHtml);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }


  async DocumentPrintPolicy(row: VcontractsModel) { 
   
    this.spinner.show();

    const WindowPrt = window.open(row.FileUrl, '', 'noopener,noreferrer');

    WindowPrt.document.close();
    WindowPrt.focus();

    this.spinner.hide();
  }







  Check(contract: VcontractsModel) {

    let index = this.LstResquest.findIndex(x => x.RequestCode == contract.RequestCode
      && x.Status == contract.Status 
      && x.ContractName ==  contract.ContractName)
    if (index > -1) {
      this.LstResquest.splice(index, 1)
    }
    else {
      this.LstResquest.push(contract)

    }


  }


  DownloadFormatMasi() {
    this.LstResquest.forEach(element => {
       this.DirectDownload(element)

    });
  }

  public operacion(element : VcontractsModel) : string{
    const hoy = new Date();
    let x = ""
    let diferenciaDias = Math.floor( (new Date(element.PolicyEndDate).getTime() - hoy.getTime() )  / (1000 * 60 * 60 * 24));

    if(diferenciaDias >= 60){
      x = "Vigente"
    }
    
    if(diferenciaDias >= 0){
      x = "Pendiente"
    }

    if(diferenciaDias <= 0){
      x = "Vencida"
    }
    return x
  }


  public async GetRequestByCode() {
    if (this.requestcode != undefined) {
      await this.Service.getRequestByCode(this.requestcode).then(
        async (res) => {
          this.Request = res;

          if (this.Request == undefined) {
              Swal.fire({
                icon: "error",
                title: this.translate.instant("Document.Messages.2"),
                showConfirmButton: false,
                timer: 3000,
              });
          }
        }
      );
    }
  }

  /* -------------------------- Exportacion de Excel y Csv ------------------------------- */

  exportExcel() {
    this.processTableInfo(this.filterItem);
    let excelDataAsJson = [
      { 
        sheetName: "Data",
        data: this.filterItemExcel
      },
      { 
        sheetName: "Filters",
        data: [""]
      }
    ]

    this.saveAsExcelFile(excelDataAsJson, `Reporte_Repositorio_T&C`);
  }

  saveAsExcelFile(excelDataAsJson: any, fileName: string): void {
    let EXCEL_EXTENSION = '.xlsx';
    JSONToExcel(excelDataAsJson,fileName + '_' + moment(String(new Date())).format('YYYYMMDD').substring(0,10) +"_"+ moment(String(new Date())).format('HHmm') + EXCEL_EXTENSION);
  }

  processTableInfo(items: VcontractsModel[]){
    this.filterItemExcel = [];
    
    items.forEach(element => {
      let filterTable = this.createFilterTable(element);
      this.filterItemExcel.push(filterTable);
    });
  }

  private createFilterTable(element: VcontractsModel): VcontractsExcelModel {
    let filterTable = new VcontractsExcelModel();
    filterTable.TipoAcuerdo = element.AgreementTypeNameFirst ?? element.AgreementTypeNameSecond;
    filterTable.Estado = this.getEstado(element.Status);
    filterTable.Iata = element.ConnectionType == 2 ? element.CodeIata : element.Iata;
    filterTable.TipoAgencia = element.ConnectionType == 2 ? "No IATA" : "IATA";
    filterTable.TipoConexion = element.NameConnection;
    filterTable.NombreComercial = element.ComercialName;
    filterTable.IDFiscalAgy = element.Nit;
    filterTable.FechaAceptacion = this.formatDate(element.RequestDate);
    filterTable.FechaAvisoTerm = this.formatDate(element.NotifyDate);
    filterTable.RepresentanteLegal = element.LegalName;
    filterTable.TipoIDRepLegal = element.LegalDocType;
    filterTable.NumeroIDRepLegal = element.LegalDocNumber;
    filterTable.Region = element.RegionName;
    filterTable.Pais = element.CountryName;
    filterTable.EstadoAcuerdo = this.getEstadoAcuerdo(element.StateCRM, element.ConnectionType);
    filterTable.InicioGarantia = this.formatDate(element.PolicyStartDate);
    filterTable.FinGarantia = this.formatDate(element.PolicyEndDate);
    filterTable.NumeroGarantia = element.WarrantyNumber;
    filterTable.TipoGarantia = element.WarrantyTypeName;

    return filterTable;
  }

  private getEstado(status: string): string {
    switch (status) {
      case "Aproved":
        return "Aprobado";
      case "Rejected":
        return "Rechazado";
      case "Created":
        return "Creado";
      default:
        return status;
    }
  }

  private formatDate(date: Date | undefined): string {
    if (!date) return "";
    return new Date(date).getDate() + "/" + new Date(date).getMonth() + "/" + new Date(date).getFullYear();
  }

  private getEstadoAcuerdo(stateCRM: number, connectionType: number): string {
    if (connectionType == 2) return "N/A";
    switch (stateCRM) {
      case 0:
        return "Activo";
      case 1:
        return "Inactivo";
      default:
        return "";
    }
  }

  /**
   * SendoToPaco
   */
  public SendToPaco() {
    window.location.href = environment.request.paco;
  }
}
